import { Component, Input } from '@angular/core';
import { Riskanalysis } from 'src/app/kuba/follow-ups/models/riskanalysis';

/**
 * Business dashboard risk analysis card (#5672).
 *
 * The approved/unapproved tabs and approval notice were removed; the card now
 * shows a single speedometer gauge whose needle sits on the median risk figure.
 */
@Component({
  selector: 'app-risk-analysis-business-widget',
  templateUrl: './risk-analysis-business-widget.component.html',
  styleUrls: ['./risk-analysis-business-widget.component.css'],
  standalone: false
})
export class RiskAnalysisWidgetComponent {
  @Input() riskAnalysis: Riskanalysis[] = [];
}
